module.exports = __webpack_public_path__ + "729480f474107a43bd76a383a2c36e79.png";